import { html } from 'lit-element';

/**
 *
 * @param {typeof LitElement} Component
 * @param {{deferTimeout: number}} params
 */
export const withDefer = (Component, params = { deferTimeout: 500 }) => {
  class Enchanced extends Component {
    static properties = {
      ...Component.properties,
      defer: { type: Boolean },
      deferTimeout: { type: Number },
      __resolved__: { type: Boolean },
    };

    constructor() {
      super();

      this.defer = true;
      this.deferTimeout = params.deferTimeout;

      this.__resolved__ = false;

      this._timeoutID = null;
    }

    connectedCallback() {
      super.connectedCallback();

      this.__resolved__ = !this.defer;
    }

    firstUpdated(_changes) {
      super.firstUpdated(_changes);

      if (this.defer) {
        this._timeoutID = setTimeout(() => (this.__resolved__ = true), this.deferTimeout);
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      if (this._timeoutID) {
        clearTimeout(this._timeoutID);
      }
    }

    render() {
      return this.__resolved__ ? super.render() : html``;
    }
  }

  return Enchanced;
};
